import React, { createContext, useContext, useEffect, useState } from 'react'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { default as themeDefault, createTheme } from '../constants/theme'
import apiCompanies from "../features/configuration/services/company"
import { userContext } from './userContext'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const user = React.useContext(userContext)
  const [theme, setTheme] = useState(themeDefault)

  useEffect(() => {
    const cachedColor = localStorage.getItem('customColor') || null
    if (cachedColor) {
      setTheme(createTheme(cachedColor))
    }

    const fetchTheme = async () => {
      try {
        if (!user?.state?.companyId) return
        const res = await apiCompanies.getDisplay()
        const color = res.customColor
        setTheme(createTheme(color))
        localStorage.setItem('customColor', color === null ? '' : color)
      } catch (err) {
        console.error('Failed to load theme:', err)
      }
    }

    fetchTheme()
  }, [user?.state?.companyId])

  const updateTheme = (newPrimary) => {
    setTheme(createTheme(newPrimary))
  }

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    // In dev (hot reload), you may land here
    return { theme: themeDefault, updateTheme: () => {} }
  }
  return context
}
